import { ContentService } from '@blk/cwp-ng-framework';

import { NamedFormatter } from './named-formatter.interface';

export class IconFormatter implements NamedFormatter {
	public static readonly BOX: string = 'box';

	constructor(public iconType?: string) {}

	public attributeName(): string {
		return 'iconType';
	}
	public format(value: any, contentSvc?: ContentService): string {
		if (this.iconType) {
			return this.iconType;
		}
		return IconFormatter.BOX;
	}
}
